<template>
    <div class="modal-content">
        <div class="modal-header border-0 text-ceter">
            <modal-close />
            <div class="modal-title">
                <h2 class="h3 px-2 pt-4 pb-1">Generuj cenówki</h2>
            </div>
        </div>
        <div class="modal-body p-x-4 py-2 text-primary">
            <p class="h6 text-center">
                Chcesz wydrukować tę cenówkę czy przejść do generatora?
            </p>
        </div>
        <div class="text-center">
            <button
                class="my-3 btn btn-secondary mt-2 mr-1 ml-1"
                @click="generateLabel"
            >
                Tylko ta cenówka

                <button-spinner
                    v-if="generateLabelLoader"
                    status="loading"
                    class="ml-3"
                />
            </button>
            <button
                class="my-3 btn btn-secondary mt-2 mr-1 ml-1"
                @click="goToLabels"
            >
                Przejdź do generatora
                <button-spinner
                    v-if="goToLabelsLoader"
                    status="loading"
                    class="ml-3"
                />
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            generateLabelLoader: false,
            goToLabelsLoader: false
        }
    },

    computed: {
        args() {
            return this.$store.getters.modalState.args
        }
    },

    methods: {
        async prepareLabels() {
            await this.$store.dispatch('unselectAllLabelGroupLabels')

            await this.$store.dispatch('loadSelectedLabelGroups', {
                groups: this.args.groups
            })
        },
        async generateLabel() {
            if (this.generateLabelLoader) return

            this.generateLabelLoader = true
            await this.prepareLabels()
            this.generateLabelLoader = false

            this.$store.dispatch('openModal', {
                component: 'ModalLabels',
                classes: 'm-labels'
            })
        },
        async goToLabels() {
            if (this.goToLabelsLoader) return

            this.goToLabelsLoader = true
            await this.prepareLabels()
            this.goToLabelsLoader = false

            this.$store.dispatch('toggleModal', false)
            this.$router.push(this.$router.resolve({ name: 'labels' }).href)
        }
    }
}
</script>
